<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.upgrade.title") }}</div>
    <hr />
    <div class="recharge-steps" v-if="step == 1">
      <p
        v-html="
          $t('dashboard.upgrade.qualify', {
            earlyStagePrice: earlyStagePrice,
            regularPrice: regularPrice,
            addOnWorth: addOnWorth,
          })
        "
      ></p>
      <router-link to="" class="note">{{
        $t("dashboard.upgrade.agreement")
      }}</router-link>
      <div class="w-100 d-flex justify-content-between">
        <div class="item">
          <BFormSelect
            v-model="memberSelection"
            :options="options"
            @change="updateSelection"
          ></BFormSelect>
        </div>
        <span class="bonus">{{
          $t("dashboard.upgrade.discount", { percent: discount })
        }}</span>
        <span class="price">${{ price }}</span>
      </div>
      <span class="note">{{
        $t("dashboard.upgrade.renew", {
          date: renewDate,
          renewPrice: renewPrice,
        })
      }}</span>
      <div class="w-100 d-flex justify-content-between total">
        <span class="item">{{ $t("dashboard.upgrade.total") }}</span>
        <span class="price">${{ total }}</span>
      </div>
      <div class="input-group custom-control-input">
        <input
          id="agree"
          type="checkbox"
          name="agree"
          :value="true"
          v-model="agree"
        />
        <label for="agree"
          ><span v-html="$t('dashboard.recharge.agree')"></span
        ></label>
      </div>
      <div class="input-group custom-control-input">
        <input
          id="affirm"
          type="checkbox"
          name="affirm"
          :value="true"
          v-model="affirm"
        />
        <label for="affirm"
          ><span v-html="$t('dashboard.recharge.affirm')"></span
        ></label>
      </div>
      <div class="alert alert-danger w-100 py-1" role="alert" v-if="showErr">
        {{ err }}
      </div>
      <div class="btn btn-gold text-white btn-pay" @click="payNow">
        {{ $t("dashboard.recharge.pay") }}
      </div>
    </div>
  </div>
</template>

<script>
import { BFormSelect } from "bootstrap-vue";

export default {
  components: {
    BFormSelect,
  },
  data() {
    return {
      step: 1,
      earlyStagePrice: 0,
      regularPrice: 0,
      addOnWorth: 0,
      discount: 0,
      memberSelection: 1,
      options: [
        {
          value: 1,
          text: "1 " + this.$tc("dashboard.upgrade.year", 1),
        },
      ],
      price: 199,
      priceList: [199],
      renewDate: "",
      renewPrice: 199,
      total: 199,
      agree: false,
      affirm: false,
      showErr: false,
      err: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取余额数据
      this.earlyStagePrice = 199;
      this.regularPrice = 599;
      this.addOnWorth = 190;
      this.discount = 84;
      this.options = [
        {
          value: 1,
          text: "1 " + this.$tc("dashboard.upgrade.year", 1),
        },
        {
          value: 2,
          text: "2 " + this.$tc("dashboard.upgrade.year", 2),
        },
        {
          value: 3,
          text: "3 " + this.$tc("dashboard.upgrade.year", 3),
        },
      ];
      this.priceList = [199, 398, 597];
    },
    updateSelection(value) {
      this.memberSelection = value;
      this.price = this.priceList[value - 1];
      this.total = this.price;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    payNow() {
      if (!this.agree || !this.affirm) {
        this.showErr = true;
        this.err = this.$t("dashboard.upgrade.err");
        return
      }
      alert(this.memberSelection + " " + this.$tc("dashboard.upgrade.year", this.memberSelection))
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
    agree: function() {
        if (this.agree && this.affirm) this.showErr = false;
    },
    affirm: function() {
        if (this.agree && this.affirm) this.showErr = false;
    },
  },
};
</script>

<style scoped>
.recharge-steps {
  align-items: flex-start;
  .item {
    color: #3b3e51;
    font-size: 1.15rem;
    font-weight: 500;
    line-height: 2.5rem;
    img {
      width: 28px;
    }
    span {
      vertical-align: middle;
    }
    select {
      border: none;
      border-right: 1rem solid transparent;
      border-radius: 0.5rem;
      padding: 0.2rem 1rem;
      background-color: #F4F9FE;
      font-size: 0.9rem;
    }
  }
  .bonus {
    color: #ff7b00;
    font-size: 1.5rem;
  }
  .price {
    color: #687b8e;
    font-size: 1.5rem;
  }
  .note {
    color: #65676b;
    text-decoration: none;
    font-size: 0.9rem;
  }
  .total {
    background-color: #e4fffb;
    padding: 1rem;
    margin: 1rem 0;
    .item {
      font-size: 1rem;
      font-weight: 400;
    }
    .price {
      color: #3b3e51;
      font-weight: 600;
    }
  }
  .custom-control-input {
    width: 100%;
    font-size: 1rem;
    line-height: 2rem;
    input[type="checkbox"] {
      display: none;
    }
    label {
      position: relative;
      cursor: pointer;
      padding-left: 1.6rem;
    }
    label::before {
      content: "";
      display: inline-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 1.3rem;
      margin-right: 0.5rem;
      background-color: transparent;
      border: 3px solid #ff00004d;
    }
    input[type="checkbox"]:checked + label:before {
      content: "\2713";
      color: white;
      font-size: 0.8rem;
      line-height: 1.3rem;
      background-color: rgb(19, 200, 255);
      border: 3px solid rgb(19, 200, 255);
    }
  }
  .btn-pay {
    align-self: flex-end;
    width: 50%;
    padding: 1rem;
    margin: 1rem 0 3rem;
    font-size: 1.25rem;
    font-weight: 600;
  }
}
</style>
